import {
  ApartmentOutlined,
  BarChartOutlined,
  EyeOutlined,
  FileSearchOutlined,
  ContactsOutlined,
  DesktopOutlined,
  DotChartOutlined,
  InfoCircleOutlined,
  LeftOutlined,
  MenuOutlined,
  SettingOutlined,
  UserOutlined,
  WindowsOutlined,
} from "@ant-design/icons";
import { Menu, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Link } from "react-router-dom";
import { getLatest } from "../../redux/actions/statsActions";
import moment from "moment";

function SideMenu() {
  const [latestImport, setLatestImport] = useState(null);
  const [width, setWidth] = useState(80);
  const latest = useSelector((state) => state.stats.latest);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!latest) {
      dispatch(getLatest());
    } else {
      const date = moment(latest).format("DD/MM/YYYY");
      const time = moment(latest).format("HH:mm");
      setLatestImport({ date, time });
    }
  }, [dispatch, latest]);

  const link = (to, text) => <Link to={to}>{text}</Link>;
  const authenticatedItems = [
    {
      key: "clients",
      icon: <UserOutlined />,
      label: "Clients",
      children: [
        { key: "Clients", icon: <UserOutlined />, label: link("/clients", "Gestion") },
        {
          key: "directory",
          icon: <ContactsOutlined />,
          label: link("/clients/directory", "Annuaire"),
        },
      ],
    },
    {
      key: "logs",
      icon: <DotChartOutlined />,
      label: "Logs",
      children: [
        { key: "map", icon: <WindowsOutlined />, label: link("/map", "Map") },
        {
          key: "logs-monitoring",
          icon: <FileSearchOutlined />,
          label: link("/logs/monitoring", "Suivi des logs"),
        },
      ],
    },
    {
      key: "supervision",
      icon: <EyeOutlined />,
      label: "Supervision",
      children: [
        {
          key: "supervision-orchestration",
          icon: <ApartmentOutlined />,
          label: link("/supervision/orchestration", "Orchestration"),
        },
        {
          key: "supervision-view-usage",
          icon: <BarChartOutlined />,
          label: link("/supervision/view-usage", "Usage des vues"),
        },
      ],
    },
    {
      key: "settings",
      icon: <SettingOutlined />,
      label: link("/settings", "Configuration"),
    },
    { key: "remote", icon: <DesktopOutlined />, label: link("/remote", "Remote") },
  ];

  const importText = latestImport
    ? `Dernier import le ${latestImport.date} à ${latestImport.time}`
    : null;
  const importItem =
    latestImport && width > 80
      ? { key: "time", disabled: true, style: { float: "right" }, label: importText }
      : latestImport
      ? {
          key: "time",
          disabled: true,
          label: (
            <Tooltip title={importText} placement="topLeft">
              <InfoCircleOutlined />
            </Tooltip>
          ),
        }
      : null;
  const items = importItem
    ? [importItem, ...authenticatedItems]
    : authenticatedItems;

  return (
    <div className="side-menu" style={{ width }}>
      <div className="fold">
        {width === 80 ? (
          <MenuOutlined onClick={() => setWidth(300)} />
        ) : (
          <LeftOutlined onClick={() => setWidth(80)} />
        )}
      </div>
      <Menu
        mode="inline"
        theme="light"
        className="menu-content"
        onSelect={() => setWidth(80)}
        inlineCollapsed={width === 80}
        items={items}
      />
    </div>
  );
}

export default SideMenu;
